export const environmentConfig = {
  enableSentry: true,
  production: true,
  skipAuthentication: false,
};
